import { render, staticRenderFns } from "./projectAdd.vue?vue&type=template&id=4ec24a3c&scoped=true"
import script from "./projectAdd.vue?vue&type=script&lang=js"
export * from "./projectAdd.vue?vue&type=script&lang=js"
import style0 from "./projectAdd.vue?vue&type=style&index=0&id=4ec24a3c&prod&scoped=true&lang=css"
import style1 from "./projectAdd.vue?vue&type=style&index=1&id=4ec24a3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec24a3c",
  null
  
)

export default component.exports